import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavController } from '@ionic/angular';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {

  public displayBackNav: boolean = false;

  @Input() title;
  constructor(
    private router: Router,
    private navCtrl: NavController

  ) { }

  ngOnInit() {
    if (this.router.url === '/protected/settings-management/account-settings' || this.router.url === '/protected/settings-management/privacy-policy') {
      this.displayBackNav = true;
    }
  }

  onNavBack() {
    // this.navCtrl.pop();
    this.navCtrl.navigateBack(['protected', 'settings-management']);
  }

}
